import { CommonModule } from '@angular/common';
import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { instanceOfRelationalOperator, RelationalOperator } from '@mtna/data-core-ts';

/**
 * Record of hints for each operator.
 * Most operators are self-explanitory, so they are left blank.
 * If a use-case arises that one needs more explanation, add it.
 */
export const RdsFilterOperatorHint: Record<RelationalOperator, string> = {
  EQ: '',
  NE: '',
  GE: '',
  GT: '',
  LE: '',
  LT: '',
  LIKE: 'Searches for a specified pattern',
  NOT_LIKE: 'Searches for the absence of a specified pattern',
  MATCHES: 'Regular expression matching',
  NOT_MATCHES: 'Regular expression matching',
  NOT_NULL: '',
};

@Pipe({
  name: 'rdsFilterOperatorHint',
})
export class FilterOperatorHintPipe implements PipeTransform {
  transform(parameter: RelationalOperator | string | null | undefined): string {
    if (instanceOfRelationalOperator(parameter)) {
      return RdsFilterOperatorHint[parameter];
    }
    return '';
  }
}

@NgModule({
  imports: [CommonModule],
  exports: [FilterOperatorHintPipe],
  declarations: [FilterOperatorHintPipe],
})
export class RdsFilterOperatorHintPipeModule {}
